/*
	This form is for Flashtalking Facebook connections.  For Mediaocean Facebook connections, see FacebookImageMO
*/

import React from "react";
import { FormSection } from "redux-form";

import { SOCIAL_AD_TYPES } from "utils/constants";
import PACController from "social/PACController";

const adType = SOCIAL_AD_TYPES.FACEBOOK_IMAGE;

export default function FacebookImage(props){
	return (
		<FormSection name={adType}>
			<PACController
				{...props}
				adType={adType}
			/>
		</FormSection>
	);
}

FacebookImage.displayName = "FacebookImageForm";
